angular.module('dnecom')
    .controller('StoreColorSchemeAppearanceSettingsController', ["$scope", "StoreUtils", "MediaUtils", "MediaSrc", function ($scope, StoreUtils, MediaUtils, MediaSrc) {
        $scope.backgroundImageMarkedForDelete = false;
        const PALETTE_FIELDS_ENUM = ['headerColor', 'menuColor', 'footerColor', 'backgroundColor', 'mobileHeaderColor'];
        const PALETTE_KEYS_ENUM = ['light', 'dark', 'bright', 'soft'];

        $scope.colorPalettes = {
            light: {
                headerColor: '#6d5cae',
                menuColor: '#ffffff',
                footerColor: '#6d5cae',
                backgroundColor: '#fafafa',
                mobileHeaderColor: '#6d5cae',
            },
            dark: {
                headerColor: '#1c1c1c',
                menuColor: '#2c2c2c',
                footerColor: '#1c1c1c',
                backgroundColor: '#c2c2c2',
                mobileHeaderColor: '#1c1c1c',
            },
            bright: {
                headerColor: '#048e7e',
                menuColor: '#c6f04e',
                footerColor: '#048e7e',
                backgroundColor: '#fcfff5',
                mobileHeaderColor: '#048e7e',
            },
            soft: {
                headerColor: '#b8daf0',
                menuColor: '#e8f6ff',
                footerColor: '#b8daf0',
                backgroundColor: '#fafafa',
                mobileHeaderColor: '#b8daf0',
            },
        }

        if (!$scope.store.properties.appearance.colorPalette) {
            $scope.store.properties.appearance.colorPalette = $scope.defaultProperties.appearance.colorPalette;
        }

        var getStoreColor = function (field) {
            return StoreUtils.getFieldValue($scope.store, 'appearance', field);
        };

        var setStoreColor = function (field, color) {
            StoreUtils.setFieldValue($scope.store, 'appearance', field, color);
        };

        $scope.save = function (form) {
            // copy value and restore on fail
            var currentBackground = $scope.store.properties.appearance.backgroundImage;

            if ($scope.backgroundImageMarkedForDelete) {
                $scope.store.properties.appearance.backgroundImage = {};
            }

            if (!$scope.$parent.save(form)) {
                $scope.store.properties.appearance.backgroundImage = currentBackground;

                return false;
            }

            if ($scope.backgroundImageMarkedForDelete && currentBackground.id) {
                MediaUtils.scheduleDelete(currentBackground.id);
            }

            MediaUtils.processDelete();
            $scope.backgroundImageMarkedForDelete = false;

            return true;
        };

        $scope.uploadBackground = function (file) {
            StoreUtils.upload($scope.store, file, function (media) {
                $scope.store.properties.appearance.backgroundImage = media;
            });
        };

        $scope.deleteBackground = function () {
            $scope.backgroundImageMarkedForDelete = true;
        };

        $scope.cancelBackgroundDeletion = function () {
            $scope.backgroundImageMarkedForDelete = false;
        };

        $scope.resetColor = function (field) {
            setStoreColor(field, $scope.defaultProperties['appearance'][field]);
        };

        $scope.toggleMobileBackground = function () {
            var value = ($scope.store.properties.appearance.mobileBackgroundImageEnabled == 0) ? 1 : 0;
            StoreUtils.setFieldValue($scope.store, 'appearance', 'mobileBackgroundImageEnabled', value);
        };

        $scope.isDefaultColor = function (field) {
            return getStoreColor(field) == null
                || getStoreColor(field).length == 0
                || (PALETTE_FIELDS_ENUM.includes(field) && $scope.colorPalettes[$scope.store.properties.appearance.colorPalette][field] == getStoreColor(field))
                || getStoreColor(field) == $scope.defaultProperties['appearance'][field];
        };

        $scope.getPaletteKeys = function () {
            return PALETTE_KEYS_ENUM;
        }

        $scope.getDefaultAppearanceColor = function (field) {
            return $scope.colorPalettes[$scope.store.properties.appearance.colorPalette][field];
        }

        $scope.changeColorPalette = function () {
            console.log('done');
            setStoreColor('headerColor', $scope.colorPalettes[$scope.store.properties.appearance.colorPalette]['headerColor']);
            setStoreColor('menuColor', $scope.colorPalettes[$scope.store.properties.appearance.colorPalette]['menuColor']);
            setStoreColor('footerColor', $scope.colorPalettes[$scope.store.properties.appearance.colorPalette]['footerColor']);
            setStoreColor('backgroundColor', $scope.colorPalettes[$scope.store.properties.appearance.colorPalette]['backgroundColor']);
            setStoreColor('mobileHeaderColor', $scope.colorPalettes[$scope.store.properties.appearance.colorPalette]['mobileHeaderColor']);
        }

        var getStoreField = function (field) {
            return StoreUtils.getFieldValue($scope.store, 'general', field);
        };

        var setStoreField = function (field, value) {
            StoreUtils.setFieldValue($scope.store, 'general', field, value);
        };

        $scope.resetStoreField = function (field) {
            setStoreField(field, $scope.defaultProperties['general'][field]);
        };

        $scope.isDefaultFieldValue = function (field) {
            return getStoreField(field) == null
                || getStoreField(field).length == 0
                || getStoreField(field) == $scope.defaultProperties['general'][field];
        };

        $scope.getPreviewBackground = function () {
            var styles = {
                background: $scope.store.properties.appearance.backgroundColor,
                backgroundSize: '20%'
            };

            if ($scope.store.properties.appearance.backgroundImage.id) {
                styles.background = 'url(' + MediaSrc.src($scope.store.properties.appearance.backgroundImage) + ')';
                styles.backgroundRepeat = $scope.store.properties.appearance.backgroundImagePosition;

                if (styles.backgroundRepeat === 'cover') {
                    styles.backgroundRepeat = 'no-repeat';
                    styles.backgroundPosition = 'center center';
                    styles.backgroundSize = '100%';
                } else if (styles.backgroundRepeat === 'repeat-x') {
                    styles.backgroundPosition = 'top left';
                    styles.backgroundSize = '40px 100%';
                } else if (styles.backgroundRepeat === 'repeat-y') {
                    styles.backgroundPosition = 'top left';
                    styles.backgroundSize = '100% 40px';
                }
            }

            return styles;
        }
    }]);
